import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { ISubmissionStatusType } from '@/shared/model/submission-status-type.model';

const baseApiUrl = 'api/submission-status-types';

export default class SubmissionStatusTypeService {
  public find(id: number): Promise<ISubmissionStatusType> {
    return new Promise<ISubmissionStatusType>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: ISubmissionStatusType): Promise<ISubmissionStatusType> {
    return new Promise<ISubmissionStatusType>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: ISubmissionStatusType): Promise<ISubmissionStatusType> {
    return new Promise<ISubmissionStatusType>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
